<div fxHide.lt-md *ngIf="GridType !=8">

  <div *ngIf="breadcrumbtype == '1' ">
    <div class="breadcrumbs"
      style="background-color: white; padding: 12px 24px; border-radius: 8px; margin-bottom: 16px; position: relative;">


      <div *ngIf="breadcrumbs.length && videoId" class="demo-btn-group">
        <button [attr.guide]="'breadcrumbs-btn-demo' + '__' + sanitizeUrl(url)" mat-raised-button color="primary"
          (click)="openVideoModal()">
          ▶ &nbsp; Watch Demo
        </button>
        <button *ngIf="tour?.stepGuideSteps?.length" [attr.guide]="'breadcrumbs-btn-tour' + '__' + sanitizeUrl(url)"
          mat-raised-button color="primary" (click)="startTour()">
          ▶ &nbsp; Tour
        </button>
      </div>

      <div class="crumbs" fxLayout="row" fxLayoutAlign="start center"
        style="margin-top: 8px; gap: 8px; margin-bottom: 10px;">
        <div class="title1" style="font-size: 18px; font-weight: 600; color: #333;">{{ currentPage }}<span *ngIf="router.url.includes('posProduct') && newTitle"> - {{ newTitle }}</span></div>
        <span style="color: #888;">|</span>

        <a [attr.guide]="'breadcrumbs-lnk-1' + '__' + sanitizeUrl(url)" class="crumb home cls" [routerLink]="['/']"
          style="text-decoration: none; align-items: center;font-weight: 500;">Home</a>

        <ng-container *ngFor="let breadcrumb of breadcrumbs; let i = index;">
          <div fxLayout="row" fxLayoutAlign="start center" style="align-items: center; gap: 4px;">
            <mat-icon class="chevron" style="color: #888;">chevron_right</mat-icon>

            <a [attr.guide]="'breadcrumbs-lnk-2' + '__' + sanitizeUrl(url)" *ngIf="i != (breadcrumbs.length - 1)"
              [routerLink]="[breadcrumb.url]" class="links cls" style="text-decoration: none">
              {{ breadcrumb.name }}
            </a>

            <span *ngIf="i == (breadcrumbs.length - 1)" class="breadcrumb-title active"
              style="font-weight: bold; color: #333;">
              {{ breadcrumb.name }}
            </span>

            <span *ngIf="router.url.includes('posProduct') && newTitle" class="breadcrumb-title active">
              <b>({{ newTitle === 'All' ? 'All Warehouse' : newTitle }})</b>
            </span>
          </div>
        </ng-container>
      </div>
    </div>
  </div>







  <div *ngIf="breadcrumbtype == '0'">
    <div class="breadcrumbs">
      <div style="background: none;" class="title1">{{ currentPage }}<span *ngIf="router.url.includes('posProduct') && newTitle"> - {{ newTitle }}</span></div>
      <div class="crumbs" fxLayout="row" fxLayoutAlign="start center">
        <a [attr.guide]="'breadcrumbs-lnk-3' + '__' + sanitizeUrl(url)" class="crumb home" [routerLink]="['/']">Home</a>
        <div class="crumb" *ngFor="let breadcrumb of breadcrumbs; let i = index;" fxLayout="row"
          fxLayoutAlign="start center">
          <mat-icon class="chevron">chevron_right</mat-icon>
          <a [attr.guide]="'breadcrumbs-lnk-4' + '__' + sanitizeUrl(url)" class="links"
            [hidden]="i == (breadcrumbs.length - 1)" [routerLink]="[breadcrumb.url]">{{breadcrumb.name}}</a>

          <span [hidden]="i != (breadcrumbs.length - 1)"
            class="breadcrumb-title active"><b>{{breadcrumb.name}}</b></span>

          <span *ngIf="router.url.includes('posProduct') && newTitle" class="breadcrumb-title active"><b>({{ newTitle === 'All' ?
              'All Warehouse' : newTitle }})</b></span>

        </div>

      </div>


      <div *ngIf="breadcrumbs.length && videoId" class="demo-btn-group">
        <button [attr.guide]="'breadcrumbs-btn-demo' + '__' + sanitizeUrl(url)" mat-raised-button color="primary"
          (click)="openVideoModal()">
          ▶ &nbsp; Watch Demo
        </button>
        <button *ngIf="tour?.stepGuideSteps?.length" [attr.guide]="'breadcrumbs-btn-tour' + '__' + sanitizeUrl(url)"
          mat-raised-button color="primary" (click)="startTour()">
          ▶ &nbsp; Tour
        </button>
      </div>

    </div>
  </div>


  <div *ngIf="breadcrumbtype == '2' ">
    <div class="custom-breadcrumb"
      style="background-color: #fff; padding: 16px 24px; border-radius: 12px; box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1); margin-bottom: 24px;width: 100%;">
      <ul class="breadcrumb" fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="12px"
        style="padding: 0; margin: 0;">

        <li class="breadcrumb-item">
          <a [attr.guide]="'breadcrumbs-lnk-5' + '__' + sanitizeUrl(url)" [routerLink]="['/']"
            class="breadcrumb-link">Home</a>
        </li>

        <ng-container *ngFor="let breadcrumb of breadcrumbs; let i = index;">
          <li class="breadcrumb-separator" *ngIf="i != (breadcrumbs.length)">
            <mat-icon class="breadcrumb-icon">chevron_right</mat-icon>
          </li>

          <li class="breadcrumb-item" *ngIf="i != (breadcrumbs.length - 1)">
            <a [attr.guide]="'breadcrumbs-lnk-6' + '__' + sanitizeUrl(url)" [routerLink]="[breadcrumb.url]"
              class="breadcrumb-link">{{ breadcrumb.name }}</a>
          </li>

          <li class="breadcrumb-item active" *ngIf="i == (breadcrumbs.length - 1)">
            <span class="breadcrumb-active">{{ breadcrumb.name }}</span>
          </li>

          <li class="breadcrumb-item active" *ngIf="router.url.includes('posProduct') && newTitle">
            <span style="font-size: 15px;" class="breadcrumb-active">({{ newTitle === 'All' ? 'All Warehouse' : newTitle }})</span>
          </li>


        </ng-container>

      </ul>

      <div *ngIf="breadcrumbs.length && videoId" class="demo-btn-group">
        <button [attr.guide]="'breadcrumbs-btn-demo' + '__' + sanitizeUrl(url)" mat-raised-button color="primary"
          (click)="openVideoModal()">
          ▶ &nbsp; Watch Demo
        </button>
        <button *ngIf="tour?.stepGuideSteps?.length" [attr.guide]="'breadcrumbs-btn-tour' + '__' + sanitizeUrl(url)"
          mat-raised-button color="primary" (click)="startTour()">
          ▶ &nbsp; Tour
        </button>
      </div>

    </div>




  </div>
  <div *ngIf="breadcrumbtype == '3' ">
    <div class="c-breadcrumbs"
      style="background-color: #f9f9f9; padding: 12px 24px; border-radius: 8px; box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1); margin-bottom: 16px;">
      <div class="c-breadcrumbs__crumbs" fxLayout="row" fxLayoutAlign="start center">
        <a [attr.guide]="'breadcrumbs-lnk-7' + '__' + sanitizeUrl(url)"
          class="c-breadcrumbs__link c-breadcrumbs__link--home" [routerLink]="['/']"
          style="display: flex; align-items: center;">
          <mat-icon color="primary" style="margin-right: 4px;">home</mat-icon>
        </a>

        <ng-container *ngFor="let breadcrumb of breadcrumbs; let i = index;">
          <div fxLayout="row" fxLayoutAlign="start center" class="c-breadcrumbs__path">
            <mat-icon class="c-breadcrumbs__icon">chevron_right</mat-icon>

            <a [attr.guide]="'breadcrumbs-lnk-8' + '__' + sanitizeUrl(url)" *ngIf="i != (breadcrumbs.length - 1)"
              [routerLink]="[breadcrumb.url]" class="c-breadcrumbs__link cls">
              {{ breadcrumb.name }}
            </a>

            <span *ngIf="i == (breadcrumbs.length - 1)" class="c-breadcrumbs__active"
              style="font-weight: bold; color: #333;">
              {{ breadcrumb.name }}<span *ngIf="router.url.includes('posProduct') && newTitle"> - {{ newTitle }}</span>
            </span>
          </div>
        </ng-container>
      </div>

      <div *ngIf="breadcrumbs.length && videoId" class="demo-btn-group">
        <button [attr.guide]="'breadcrumbs-btn-demo' + '__' + sanitizeUrl(url)" mat-raised-button color="primary"
          (click)="openVideoModal()">
          ▶ &nbsp; Watch Demo
        </button>
        <button *ngIf="tour?.stepGuideSteps?.length" [attr.guide]="'breadcrumbs-btn-tour' + '__' + sanitizeUrl(url)"
          mat-raised-button color="primary" (click)="startTour()">
          ▶ &nbsp; Tour
        </button>
      </div>

    </div>




  </div>
  <div *ngIf="breadcrumbtype == '4' " class="breadcrumbs">
    <!-- <div id="crumbs" fxLayout="column" fxLayoutAlign="start stretch" style="margin-bottom: 10px;">
    
      <ul fxLayout="row" fxLayoutGap="10px">
        <li fxFlex="none">
          <a href="#1">
            <i class="fa fa-home" aria-hidden="true"></i>
          </a>
        </li>
        <li fxFlex="none">
          <a href="#2">
            <i class="fa fa-shopping-bag" aria-hidden="true"></i> Shop
          </a>
        </li>
        <li fxFlex="none">
          <a href="#3">
            <i class="fa fa-cart-plus" aria-hidden="true"></i> Cart
          </a>
        </li>
        <li fxFlex="none">
          <a href="#4">
            <i class="fa fa-credit-card-alt" aria-hidden="true"></i> Checkout
          </a>
        </li>
      </ul>
    </div> -->


    <div id="crumbs" fxLayout="column" fxLayoutAlign="center stretch" style="margin-bottom: 10px;">

      <ul>
        <!-- Home breadcrumb -->
        <li>
          <a [attr.guide]="'breadcrumbs-lnk-9' + '__' + sanitizeUrl(url)" [routerLink]="['/']">
            <i class="fa fa-home" aria-hidden="true"> <mat-icon style="margin-right: 4px;">home</mat-icon></i>
          </a>
        </li>

        <!-- Looping through the breadcrumbs -->
        <li *ngFor="let breadcrumb of breadcrumbs; let i = index">
          <a [attr.guide]="'breadcrumbs-lnk-10' + '__' + sanitizeUrl(url)" [routerLink]="[breadcrumb.url]"
            *ngIf="i < breadcrumbs.length - 1">
            <i [class]="breadcrumb.icon" aria-hidden="true"></i> {{ breadcrumb.name }}
          </a>
          <a *ngIf="i === breadcrumbs.length - 1">
            <i [class]="breadcrumb.icon" aria-hidden="true"></i> <b>{{ breadcrumb.name }}<span *ngIf="router.url.includes('posProduct') && newTitle"> - {{ newTitle }}</span></b>
          </a>
        </li>
      </ul>
    </div>


    <div *ngIf="breadcrumbs.length && videoId" class="demo-btn-group">
      <button [attr.guide]="'breadcrumbs-btn-demo' + '__' + sanitizeUrl(url)" mat-raised-button color="primary"
        (click)="openVideoModal()">
        ▶ &nbsp; Watch Demo
      </button>
      <button *ngIf="tour?.stepGuideSteps?.length" [attr.guide]="'breadcrumbs-btn-tour' + '__' + sanitizeUrl(url)"
        mat-raised-button color="primary" (click)="startTour()">
        ▶ &nbsp; Tour
      </button>
    </div>







  </div>


  <div *ngIf="breadcrumbtype == '5' ">
    <div class="c-breadcrumbs" style="padding: 12px 16px; margin-bottom: 16px;">
      <h1 style="font-size: 1.5rem; font-weight: 600; color: #333; margin: 0;">
        {{ breadcrumbs[breadcrumbs.length - 1]?.name }}<span *ngIf="router.url.includes('posProduct') && newTitle"> - {{ newTitle }}</span>
      </h1>
    </div>


    <div *ngIf="breadcrumbs.length && videoId" class="demo-btn-group">
      <button [attr.guide]="'breadcrumbs-btn-demo' + '__' + sanitizeUrl(url)" mat-raised-button color="primary"
        (click)="openVideoModal()">
        ▶ &nbsp; Watch Demo
      </button>
      <button *ngIf="tour?.stepGuideSteps?.length" [attr.guide]="'breadcrumbs-btn-tour' + '__' + sanitizeUrl(url)"
        mat-raised-button color="primary" (click)="startTour()">
        ▶ &nbsp; Tour
      </button>
    </div>



  </div>

</div>


<div fxHide.lt-md *ngIf="GridType == 8 && enableDemoVideoLinks == 1">
  <div guide="watch-demo" class="video-banner" fxLayout="row" fxLayoutAlign="start center" style="width: 100%;">

    <div class="video-left">
      <mat-icon>play_circle</mat-icon>
      <span>Need help? Watch demo video</span>
    </div>

    <div style="flex: 1;"></div>

    <div style="display: flex; gap: 8px; align-items: center; margin-left: auto;">
      <button [attr.guide]="'breadcrumbs-btn-watch' + '__' + sanitizeUrl(url)" mat-raised-button
        matTooltip="Click here for Demo Video" matTooltipPosition="below" color="primary" (click)="openVideoModal()">
        ▶ &nbsp; Watch Demo
      </button>

      <button *ngIf="tour?.stepGuideSteps?.length" [attr.guide]="'breadcrumbs-btn-tour' + '__' + sanitizeUrl(url)"
        mat-raised-button matTooltip="Click here for Tour" matTooltipPosition="below" color="primary"
        (click)="startTour()">
        ▶ &nbsp; Tour
      </button>
    </div>

  </div>

</div>


<div class="modal-backdrop" *ngIf="showVideoModal" (click)="closeVideoModal()">
  <div class="video-modal" (click)="$event.stopPropagation()">
    <button [attr.guide]="'breadcrumbs-btn-12' + '__' + sanitizeUrl(url)" class="close-button"
      (click)="closeVideoModal()">&times;</button>
    <div class="video-container">
      <iframe width="100%" height="100%" [src]=" (youtubeUrl + videoId + '?autoplay=1') | safe: 'resourceUrl'"
        frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
        allowfullscreen></iframe>
    </div>
  </div>
</div>